import React from "react";

// CSS
import "../../css/black-link.css";

class BlackButton extends React.PureComponent {
	render() {
		return (
			<button
				onClick={this.props.clickHandler}
				disabled={this.props.disabled}
				className="btn black-link"
			>
				{this.props.children}
			</button>
		);
	}
}

export default BlackButton;



// WEBPACK FOOTER //
// ./src/components/utils/BlackButton.js